if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',

    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();

          if(window.innerWidth > 999) return
        
          this.addToCartButton = document.querySelector("buy-buttons button[type='submit']");
          this.addToCartButtonOffset = this.addToCartButton.offsetTop + this.addToCartButton.offsetHeight;
          this.stickyAddToCartButton = this.querySelector('.add-to-cart-sticky');
          this.colorSwatches = this.querySelectorAll('.ColorSwatch');

          this.lastScrollY = window.scrollY;
          this.init();
      }
      
      init() {
        this.stickyAddToCartButton.addEventListener("click", this.handleUpsellAddToCart.bind(this));
        this.colorSwatches.forEach((swatch) => swatch.addEventListener("click", this.handleVariantChange.bind(this)));
        document.addEventListener("scroll", this.handleStickyElementWhenScrolling.bind(this)); 
        document.addEventListener("variant:change", this.handleMainVariantChange.bind(this));
      }

      handleStickyElementWhenScrolling() {
        const currentScrollY = window.scrollY;

        if (currentScrollY >= this.addToCartButtonOffset) {
          currentScrollY > this.lastScrollY ? this.style.bottom = '-100%' : this.style.bottom = '0';
        } else {
          this.style.bottom = '-100%';
        }

        this.lastScrollY = currentScrollY;
      }

      handleVariantChange(swatchElement) {
        const swatch = event.target.classList.contains("ColorSwatch") ? event.target : swatchElement;
        const productImage = this.querySelector(".sticky-product-image img");
        const productInputId = this.querySelector(".sticky-product-id-input");

        // update variant id
        const variantId = swatch.getAttribute("data-variant-id");
        productInputId.value = variantId;

        // update variant image
        const variantImage = swatch.getAttribute("data-variant-image");
        productImage.setAttribute("src", variantImage);

        this.handleSwatchSelection(swatch);
      }

      handleMainVariantChange(event) {
        const variantName = event.detail.variant.public_title;
        const variantLabelElement = this.querySelector(`[title='${variantName}'].ColorSwatch`);
        this.handleVariantChange(variantLabelElement);
      }

      handleSwatchSelection(swatch) {
        this.colorSwatches.forEach((element) => element.classList.remove("active"));
        swatch.classList.add("active");
        swatch.click();
      }

      handleUpsellAddToCart(event) {
          event.preventDefault();
          const productId = event.target.querySelector(".sticky-product-id-input").value;
          const productQuantity = parseInt(this.querySelector('.quantity-selector__input').value);
  
          event.target.setAttribute("disabled", true);
  
          const formData = {
              items: [
                  {
                      id: productId,
                      quantity: productQuantity,
                  }
              ]
          };
  
          fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
          })
          .then((response) => response.json())
          .then(function (data) {
              if (data.status === 422) {
                  console.log("error");
              } else {
                  event.target.removeAttribute("disabled");
                  document.documentElement.dispatchEvent(
                      new CustomEvent("cart:refresh", {
                          bubbles: true,
                      })
                  )
                  
                  // open cart drawer
                  document.querySelector('[aria-controls="cart-drawer"]').click();
              }
          })
          .catch((error) => {
              console.error("Fetch error:", error);
          });
      }
    }
  )
}